export const AVATAR_TYPE = {
  USER: 'user',
  PROJECT: 'project',
}
